import P from "../../components/Paragraph";
import useCanvasContainer from "./hooks/useCanvasContainer";
import Loader from "../../components/Loader";
import { MathJax } from "better-react-mathjax";

const CanvasContainer = () => {
  const { canvasObjects, hash, isLoading, panelExpanded } =
    useCanvasContainer();

  if (isLoading) {
    return <Loader small />;
  }

  if (!panelExpanded) {
    return null;
  }

  return (
    <div
      style={{
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "var(--gap-base)",
      }}
    >
      {canvasObjects.map((object, idx) => {
        if (object?.type?.toLowerCase() === "png") {
          return (
            <img
              key={`${hash}-${idx}`}
              src={`data:image/png;base64,${object.data}`}
              style={{ maxWidth: "100%" }}
              alt={"Canvas drawing"}
            />
          );
        }
        if (object?.type?.toLowerCase() === "svg") {
          return (
            <img
              key={`${hash}-${idx}`} 
              src={`data:image/svg+xml;base64,${object.data}`}
              style={{ maxWidth: "100%" }}
              alt={"Canvas drawing"}
            />
          );
        }
        if (object?.type?.toLowerCase() === "latex") {
          return (
            <MathJax key={`${hash}-${idx}`} inline dynamic>
              {object?.data}
            </MathJax>
          );
        }
        if (!!object?.data) {
          return <P key={`${hash}-${idx}`}>{object?.data}</P>;
        }
        return null;
      })}
    </div>
  );
};

export default CanvasContainer;
